import { apiSlice } from "@/redux/apiSlice";
import { ApiResponse } from "@/types";
import { DashboardConfigResponse } from "@/types/dashboard-config";

export const dashboardConfigApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getDashboardConfig: builder.query<DashboardConfigResponse, { orgId: number }>({
        query: ({ orgId }) => ({
          url: `/settings?groups=dashboard_configuration&org_id=${orgId}`,
          method: "GET",
          headers: { Accept: "application/json" },
        }),
        providesTags: ["SysConfig"],
      }),

      updateDashboardConfig: builder.mutation<
        ApiResponse,
        { dashboard_configuration: Record<string, string> }
      >({
        query: (data) => ({
          url: "/settings/groups",
          method: "PUT",
          body: data,
          headers: { Accept: "application/json" },
        }),
        invalidatesTags: ["SysConfig"],
      }),
    };
  },
});

export const {
  useGetDashboardConfigQuery,
  useUpdateDashboardConfigMutation,
} = dashboardConfigApi;
